import {Component} from 'react'
import Cookies from 'js-cookie'
import {Redirect} from 'react-router-dom'
import './index.css'

class Login extends Component {
  state = {user: '', passwords: '', isSuccess: false, err: ''}

  onUser = event => {
    this.setState({user: event.target.value})
  }

  onPassword = event => {
    this.setState({passwords: event.target.value})
  }

  onSuccess = jwtToken => {
    const {history} = this.props
    Cookies.set('jwt_token', jwtToken, {expires: 30})
    history.replace('/')
  }

  onSubmitCred = async event => {
    event.preventDefault()
    const {user, passwords} = this.state
    const userDetails = {username: user, password: passwords}
    const url = 'https://apis.ccbp.in/login'
    const options = {
      method: 'POST',
      body: JSON.stringify(userDetails),
    }
    const response = await fetch(url, options)
    const data = await response.json()
    if (response.ok === true) {
      this.onSuccess(data.jwt_token)
      this.setState({isSuccess: true})
    } else {
      this.setState({isSuccess: false, err: data.error_msg})
    }
  }

  render() {
    const {isSuccess, err} = this.state
    const jwtToken = Cookies.get('jwt_token')
    if (jwtToken !== undefined) {
      return <Redirect to="/" />
    }
    return (
      <div className="login-bg">
        <div className="login-card">
          <img
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
            className="login-logo"
          />

          <form onSubmit={this.onSubmitCred}>
            <label htmlFor="user" className="login-label">
              USERNAME
            </label>
            <input
              id="user"
              className="login-input"
              onChange={this.onUser}
              placeholder="Username"
            />

            <label htmlFor="password" className="login-label">
              PASSWORD
            </label>
            <input
              id="password"
              type="password"
              className="login-input"
              onChange={this.onPassword}
              placeholder="Password"
            />

            <button type="submit" className="login-btn">
              Login
            </button>

            {!isSuccess && <p className="error-msg">{err}</p>}
          </form>
        </div>
      </div>
    )
  }
}
export default Login
